import React from "react";
import { observer } from "mobx-react";
import { Button, ButtonGroup, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Dashboard } from "@uppy/react";
import FlashMessage from "~/components/FlashMessage";
import FlashMessageStore from "~/stores/FlashMessageStore";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

@observer
class UploadMultipleReplacePanoramaSection extends React.Component {
  render() {
    const { uploader, goToImmersive3dTourProjectSectionCallback, flashMessageStore } = this.props;

    return (
      <>
        <Grid.Row>
          <Grid.Column width={8}>
            <h3 className="ui header">Upload multiple panoramas</h3>
          </Grid.Column>
          <Grid.Column width={8} textAlign="right">
            <ButtonGroup>
              <Button
                secondary
                onClick={() => {
                  goToImmersive3dTourProjectSectionCallback();
                }}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </Grid.Column>
        </Grid.Row>
        <FlashMessage flashMessageStore={flashMessageStore} />
        <Grid.Row>
          <Grid.Column>
            <Dashboard
              uppy={uploader}
              showLinkToFileUploadResult={false}
              width="100%"
              height="300px"
              proudlyDisplayPoweredByUppy={false}
              showSelectedFiles={false}
              showProgressDetails
            />
          </Grid.Column>
        </Grid.Row>
      </>
    );
  }
}

UploadMultipleReplacePanoramaSection.propTypes = {
  uploader: PropTypes.object.isRequired,
  goToImmersive3dTourProjectSectionCallback: PropTypes.func.isRequired,
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore),
};

export default UploadMultipleReplacePanoramaSection;
